import { render, staticRenderFns } from "./OrderInfoModal.vue?vue&type=template&id=617b6dbb&scoped=true&"
import script from "./OrderInfoModal.vue?vue&type=script&lang=js&"
export * from "./OrderInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoModal.vue?vue&type=style&index=0&id=617b6dbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b6dbb",
  null
  
)

export default component.exports